import React, { useState, useEffect, useRef } from "react";
import { styled } from "styled-components";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { StaticImage } from "gatsby-plugin-image";
import { useStaticQuery, graphql } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import { useLocation } from "@reach/router";
//assets
import logo from "assets/svg/logo.svg";

// Styles
import colors from "styles/colors.js";
import typographySizes from "styles/typographySizes.js";
import mediaQuery from "styles/mediaQuery.js";
import distances from "styles/distances.js";

// Components
import Btn from "components/global/Btn.js";
import MainWrapper from "components/global/MainWrapper.js";
import Body from "components/global/typography/text/Body.js";
import TextWithLineBreaks from "components/global/typography/TextWithLineBreaks.js";
// Register ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

const FooterWrapper = styled.footer`
display: flex;
flex-direction: column-reverse; 


  position: relative;
  height: 70rem;

  padding-bottom: 6rem;


overflow: hidden;

a{
  color: ${colors.dark};
  text-decoration: none;
  transition: all 0.3s ease;
  &:hover{
    opacity: 0.5;
    transition: all 0.3s ease;
  }
}
`;

const StyledMainWrapper = styled(MainWrapper)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr auto;
  height: initial;
  gap: ${distances.gapBig}rem;
  grid-template-areas: "mainInfo newsletter" "bottom bottom";
  @media (max-width: ${mediaQuery.tablet}) {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto;
    grid-template-areas:"newsletter" "mainInfo"  "bottom";
    gap: 6rem;
  }
`;

const ImageWrapper = styled.div`
  position: absolute;
  left: -10rem;
  width: 100%;
  height: 100%; /* Make it taller for parallax effect */
z-index: -1;
top: 5rem; 

  .gatsby-image-wrapper {
    width: 100% !important;
    height: 140% !important;
      @media (max-width: ${mediaQuery.tablet}) {
        height: 100% !important;
      }
  }
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top left;
  }
  
  &.image-2 {
    left: initial; 

    top: -5rem !important; 
    transform: scaleX(-1);
  }

  @media (max-width: ${mediaQuery.tablet}) {
    left: 0rem;
  }
`;

const MainInfo = styled.div`
  grid-area: mainInfo;

  display: grid;
  gap: ${distances.gapBig}rem;
  grid-template-columns: 1fr 1fr 1fr;

  p{
  color: ${colors.dark};
    
  }


  @media (max-width: ${mediaQuery.desktop}) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: ${mediaQuery.tablet}) {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto;
    grid-template-areas: "adress ." ". contact";
    gap: 0;

  }
`;

const Column = styled.div`
  &.adress{
    @media (max-width: ${mediaQuery.tablet}) {
      grid-area: adress;
    }
  }
  &.contact{
    @media (max-width: ${mediaQuery.tablet}) {
      grid-area: contact;
    }
  }
`;

const Title = styled.h4`
  font-size: ${typographySizes.text.body.size.desktop}rem;
  line-height: ${typographySizes.text.body.lineHeight};
  color: ${colors.dark};
  text-shadow: 0px 0px ${distances.shadowSmall}rem ${({ color }) => color};

  &.align-right{
    text-align: right;
  }
`;

const FooterText = styled.p`
  font-size: ${typographySizes.text.small.size.desktop}rem;
  line-height: ${typographySizes.text.small.lineHeight};
  color: ${colors.dark};
  text-shadow: 0px 0px ${distances.shadowSmall}rem ${({ color }) => color};
  margin-top: 0.8rem;
  text-transform: uppercase;
  &.no-margin{
    margin-top: 0;
  }

  a{
    display: block;
  }
`;

const BottomRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${distances.gapBig}rem;
  grid-area: bottom;
  margin-top: 4rem;
a{
  font-size: ${typographySizes.text.small.size.desktop}rem;
  line-height: ${typographySizes.text.small.lineHeight};
  text-transform: uppercase;
  text-shadow: 0px 0px ${distances.shadowSmall}rem ${({ color }) => color};

}

@media (max-width: ${mediaQuery.tablet}) {
  grid-template-columns: 1fr;
  grid-template-rows: auto auto;
  grid-template-areas: "bottom";
  gap: 1rem;
}
`;

const LinksWrapper = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
`;

const SocialMedia = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 4rem;
`;

const StyledGatsbyImage = styled(GatsbyImage)`
  width: 2rem;
  height: 2rem;
`;

const NewsletterWrapper = styled.div`
  grid-area: newsletter;


`;

const NewsletterForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  input{
    
    height: 3.2rem;
    padding: 0 1rem;
    box-sizing: border-box;
    flex: 1;
    background-color: ${colors.white};

    &::placeholder{
      color: ${colors.dark}50;
      text-transform: uppercase;
    }
  }
`;

const InputWrapper = styled.div`
display: flex;
margin-top: 4rem;
`;

const Footer = () => {
  const data = useStaticQuery(graphql`
    query FooterQuery {
     strapiGlobal {
    Address
    Address_link
    Address_title
    Contact_links {
      Link
      Name
    }
    Contact_title
    Footer_links {
      Link
      Name
    }
    Newsletter_bottom_title
    Newsletter_top_title
    Social_media {
      Link
      Image {
        localFile {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
  }
    }
  `);

  const footer_links = data.strapiGlobal.Footer_links;

  const footerRef = useRef(null);
  const image1Ref = useRef(null);
  const image2Ref = useRef(null);

  const location = useLocation();

  useEffect(() => {
    const footer = footerRef.current;
    const image1 = image1Ref.current;
    const image2 = image2Ref.current;

    if (!footer || !image1 || !image2) return;

    // Check if it's mobile
    const isMobile = window.innerWidth <= 768;

    // Mouse parallax effect
    const handleMouseMove = (e) => {
      const { clientX, clientY } = e;
      const { innerWidth, innerHeight } = window;

      // Calculate mouse position as percentage (-1 to 1)
      const xPercent = (clientX / innerWidth - 0.5) * 2;
      const yPercent = (clientY / innerHeight - 0.5) * 2;

      // Apply subtle parallax movement (adjust multiplier for intensity)
      const moveIntensity = 15; // pixels

      gsap.to(image1, {
        x: xPercent * moveIntensity,
        y: yPercent * moveIntensity,
        duration: 2.3,
        ease: "power2.out",
      });

      gsap.to(image2, {
        x: xPercent * moveIntensity * -0.5, // Opposite direction, less intensity
        y: yPercent * moveIntensity * -0.5,
        duration: 2.4,
        ease: "power2.out",
      });
    };

    // Small delay to ensure DOM is ready after page transition
    const initParallax = () => {
      // Kill any existing ScrollTriggers for this footer first
      ScrollTrigger.getAll().forEach((trigger) => {
        if (trigger.trigger === footer) {
          trigger.kill();
        }
      });

      // Reset image positions
      gsap.set([image1, image2], { yPercent: 0, x: 0, y: 0 });

      // Create scroll parallax effect for both images
      const parallaxTl = gsap.timeline({
        scrollTrigger: {
          trigger: footer,
          start: "top bottom",
          end: "bottom top",
          scrub: 1,
          invalidateOnRefresh: true,
        },
      });

      // Move first image slower (classic parallax)
      parallaxTl.to(
        image1,
        {
          yPercent: -10,
          ease: "none",
        },
        0
      );

      // Move second image in opposite direction for more dynamic effect
      parallaxTl.to(
        image2,
        {
          yPercent: 20,
          ease: "none",
        },
        0
      );

      return parallaxTl;
    };

    // Add mouse move listener only on desktop
    if (!isMobile) {
      window.addEventListener("mousemove", handleMouseMove);
    }

    // Delay to ensure page transition is complete
    const timeoutId = setTimeout(() => {
      initParallax();
      ScrollTrigger.refresh();
    }, 100);

    return () => {
      clearTimeout(timeoutId);
      // Remove listener only if it was added (desktop)
      if (!isMobile) {
        window.removeEventListener("mousemove", handleMouseMove);
      }
      ScrollTrigger.getAll().forEach((trigger) => {
        if (trigger.trigger === footer) {
          trigger.kill();
        }
      });
    };
  }, [location.pathname]);

  return (
    <>
      <FooterWrapper id="footer" ref={footerRef}>
        <ImageWrapper ref={image1Ref}>
          <StaticImage
            objectFit="cover"
            src="../../assets/images/footer-bg.png"
            alt="footer"
          />
        </ImageWrapper>
        <ImageWrapper className="image-2" ref={image2Ref}>
          <StaticImage
            objectFit="cover"
            src="../../assets/images/footer-bg.png"
            alt="footer"
          />
        </ImageWrapper>
        <StyledMainWrapper>
          <MainInfo>
            <Column className="adress">
              <Title className="align-right">
                {data.strapiGlobal.Address_title}
              </Title>
              <a href={data.strapiGlobal.Address_link} target="_blank">
                <FooterText>
                  <TextWithLineBreaks text={data.strapiGlobal.Address} />
                </FooterText>
              </a>
              <SocialMedia>
                {data.strapiGlobal.Social_media.map((social) => (
                  <a href={social.Link} target="_blank">
                    <StyledGatsbyImage
                      image={
                        social.Image.localFile.childImageSharp.gatsbyImageData
                      }
                      alt={social.Name}
                    />
                  </a>
                ))}
              </SocialMedia>
            </Column>
            <Column className="contact">
              <Title className="align-right">
                {data.strapiGlobal.Contact_title}
              </Title>
              <FooterText>
                {data.strapiGlobal.Contact_links.map((link) => (
                  <a href={link.Link} target="_blank">
                    {link.Name}
                  </a>
                ))}
              </FooterText>
            </Column>
          </MainInfo>
          {/* <NewsletterWrapper>
            <Title>{data.strapiGlobal.Newsletter_top_title}</Title>
            <FooterText className="no-margin">
              {data.strapiGlobal.Newsletter_bottom_title}
            </FooterText>
            <NewsletterForm>
              <InputWrapper>
                <input type="email" placeholder="Podaj swój e-mail" />
                <Btn color={colors.dark} type="submit">
                  Subscribe
                </Btn>
              </InputWrapper>
            </NewsletterForm>
          </NewsletterWrapper> */}
          <BottomRow>
            <LinksWrapper>
              {footer_links.map((link) => (
                <a href={link.Link} key={link.Name} target="_blank">
                  {link.Name}
                </a>
              ))}
            </LinksWrapper>
            <a href="https://we3studio.pl" target="_blank">
              well designed by we3studio.pl
            </a>
          </BottomRow>
        </StyledMainWrapper>
      </FooterWrapper>
    </>
  );
};

export default Footer;
